var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('p',{staticClass:"text-center"},[_c('img',{attrs:{"src":_vm.logo()}})]),_c('h2',{staticClass:"text-center title"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.title)))])])}
var staticRenderFns = []

export { render, staticRenderFns }